// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"65520357","286":"ee2725cb","435":"adb2b5f1","453":"d48df938","484":"e64f4430","574":"8b0f88d8","642":"e98a4b17","728":"ff5aaa71","872":"31edd248","994":"28a8e54e"}[chunkId] + ".chunk.js";
};